export { AutoCompleteSearchComponent } from './auto-complete-search.component';